import { defineStore } from 'pinia';
import { usdt_abi, token_abi } from '@/utils/ABI';
import { commonStore } from './common';
// const common_store = commonStore();
import { balanceUtil } from '@/utils/index.js';
import Web3 from 'web3';
const usdt_addr = '0x816E64Ca488f892a56E4479ad52a997A72100266';
const token_addr = '0x75C4b1aC49Cf5899359a2470Fc80affa0FAdc676';
export const swapStore = defineStore('swap', {
  state: () => {
    return {
      usdtMethods: {},
      usdtEmpower: false,
      tokenMethods: {},
      tokenEmpower: false,
      nftSpender: '0xEb06Ef9C3Fc755C118E38c578D0897f7ecD141DD',
      marketSpender: '0x12AC92EF3b57b319e503223Fdf12147057e27C4a',
      hasEmpower:
        (sessionStorage.getItem('tokenEmpower') &&
          sessionStorage.getItem('tokenEmpower') != 'false') ||
        false,
      address: sessionStorage.getItem('address'),
      marketEmpower:
        (sessionStorage.getItem('marketEmpower') &&
          sessionStorage.getItem('marketEmpower') != 'false') ||
        false,
      usdtMarketEmpower:
        (sessionStorage.getItem('usdtMarketEmpower') &&
          sessionStorage.getItem('usdtMarketEmpower') != 'false') ||
        false,
      balacne: '',
    };
  },
  actions: {
    async getBalance() {
      const common_store = commonStore();
      const balance = await this.tokenMethods
        .balanceOf(common_store.address)
        .call();
      this.balacne = balance > 0 ? balanceUtil(balance + '') : balance;
    },
    setEmpower() {
      this.hasEmpower = true;
      sessionStorage.setItem('tokenEmpower', true);
    },
    setMarketEmpower() {
      this.marketEmpower = true;
      sessionStorage.setItem('marketEmpower', true);
    },
    setUsdtEmpower() {
      this.usdtMarketEmpower = true;
      sessionStorage.setItem('usdtMarketEmpower', true);
    },
    async getUsdtMethods() {
      const common_store = commonStore();
      const walletObj =
        common_store.walletType == 'BinanceChain'
          ? window.BinanceChain
          : window.ethereum;
      const web3 = new Web3(walletObj);
      const rpoContract = new web3.eth.Contract(usdt_abi, usdt_addr);
      this.usdtMethods = rpoContract.methods;

      const marketEmpower = await this.usdtMethods
        .allowance(common_store.address, this.marketSpender)
        .call();
      this.usdtMarketEmpower = +marketEmpower > 1000000 * 1e18;
      sessionStorage.setItem('usdtMarketEmpower', this.usdtMarketEmpower);
      this.usdtEmpower = true;
    },
    async getTokenMethods() {
      const common_store = commonStore();
      const walletObj =
        common_store.walletType == 'BinanceChain'
          ? window.BinanceChain
          : window.ethereum;
      const web3 = new Web3(walletObj);

      const rpoContract = new web3.eth.Contract(token_abi, token_addr);
      this.tokenMethods = rpoContract.methods;

      const res = await this.tokenMethods
        .allowance(common_store.address, this.nftSpender)
        .call();
      const marketEmpower = await this.tokenMethods
        .allowance(common_store.address, this.marketSpender)
        .call();
      this.hasEmpower = +res > 1000000 * 1e18;
      sessionStorage.setItem('tokenEmpower', this.hasEmpower);
      this.marketEmpower = +marketEmpower > 1000000 * 1e18;
      sessionStorage.setItem('marketEmpower', this.marketEmpower);
      this.tokenEmpower = true;
    },
  },
});
